import { create } from 'zustand';

const useWalletsStore = create((set) => ({
  leather: {},
  phantom: {},
  upsertWallet: (wallet, metadata) => set((state) => ({ [wallet]: metadata })),
}));

export { useWalletsStore };